
import { Card } from "@mui/material";
import { CSSProperties } from "react";
import { theme } from "theme";


type CardTotalizadorProps = {
    id: string;
    disabled?: boolean;
    children: JSX.Element | JSX.Element[];
};

const CardTotalizador = (props: CardTotalizadorProps) => {
    return (
        <Card
            id={props.id + '-card'}
            sx={{ borderRadius: 5, paddingX: '15px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}
            className={`card-totalizador-pedido ${props.disabled && 'isVisualizar'}`}
        >
            {props.children}
        </Card>
    );
};

type CardTotalizadorValueProps = {
    id: string;
    disabled?: boolean;
    color?: string;
    value?: string | number;
    children?: JSX.Element | JSX.Element[];
    style?: CSSProperties;
};

export const CardTotalizadorValue = (props: CardTotalizadorValueProps) => {
    return <h2
        id={props.id + '-card-value'}
        className="valor-totalizador"
        style={{
            color: props.disabled ? theme.palette.text.disabled : props.color,
            margin: 0,
            ...props.style,
        }}
    >
        {props.children ?? props.value}
    </h2>;
};

type CardTotalizadorLabelProps = {
    id: string;
    label: string;
    color?: string;
    disabled?: boolean;
    style?: CSSProperties;
};

export const CardTotalizadorLabel = (props: CardTotalizadorLabelProps) => {
    return <h4
        id={props.id + '-card-label'}
        className="label-totalizador"
        style={{
            color: props.disabled ? theme.palette.text.disabled : props.color,
            margin: 0,
            ...props.style,
        }}
    >
        {props.label}
    </h4>;
};


export default CardTotalizador;
